export default __webpack_public_path__ + "static/media/hollow.b3f6d42e.svg";